import { useState } from "react";

import { ChevronDownIcon } from "components/icons";

import { useTranslationContext } from "context/TranslationContext";
import cn from "lib/cn";

import styles from "./SelectField.module.css";

export interface SelectFieldProps {
  selected?: number;
  label?: string;
  options: number[];
  onSelect?: (option: number) => void;
}

const SelectField = ({
  selected,
  label,
  options,
  onSelect,
}: SelectFieldProps) => {
  const { t } = useTranslationContext();
  const [openItem, setOpenItem] = useState(false);

  const handleOnClickField = () => {
    setOpenItem((prev) => !prev);
  };

  const handleOnBlurField = () => {
    setOpenItem(false);
  };

  const handleOnSelectOption = (option: number) => {
    if (onSelect) onSelect(option);
  };

  return (
    <div className={styles.container}>
      <div className="flex items-center gap-2 text-gray-950">
        <div>{label ? t(label) : ""}</div>
        <div
          tabIndex={5}
          className={styles.field}
          onClick={handleOnClickField}
          onBlur={handleOnBlurField}
        >
          <div
            className={cn(
              styles.select_field_container,
              "flex items-center gap-1"
            )}
          >
            <div>{selected || options[0]}</div>
            <div>
              <ChevronDownIcon viewBox="0 -2 12 12" />
            </div>
          </div>

          {openItem && (
            <div className={styles.item_wrapper}>
              <div className={styles.item_container}>
                {options.map((option, index) => (
                  <div
                    key={index}
                    className={styles.item}
                    onClick={() => handleOnSelectOption(option)}
                  >
                    {option}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectField;
